export default {


    getTenants(filters, options) {
        this.cancelQRequest("QTenantsGet");
        var params = {
            ...options,
            ...filters
        }
        return this.getRequest('/api/private/tenants', params, "QTenantsGet").then(function(json) {
                return json
            },
            function(error) {
                return error
            })
    },

    getTenant(id, filters, options) {
        this.cancelQRequest("QTenantGet");
        var params = {
            ...options,
            ...filters
        }
        return this.getRequest('/api/private/tenants/' + id, params, "QTenantGet").then(function(json) {
                return json
            },
            function(error) {
                return error
            })
    },

    saveTenant(id, tenant) {
        if (id == 'new') {
            return this.postRequest('/api/private/tenants', tenant).then(function(json) {
                    return json
                },
                function(error) {
                    return error
                })
        } else {
            return this.putRequest('/api/private/tenants/' + id, tenant).then(function(json) {
                    return json
                },
                function(error) {
                    return error
                })
        }
    },

    saveTheme(id, tenant, logo) {
        var payload = {
            ...tenant,
            'logo' : logo
        }
        return this.putRequest('/api/private/tenants/' + id + '/theme', payload).then(function(json) {
            return json
        },
        function(error) {
            return error
        })
    },
    impersonateTopLevelAgent(agentcode) {
        return this.getRequest('/api/private/impersonate/' + agentcode).then(
            function(json) {
                return json
            },
            function(error) {
                return error
            })
    },
    transferTenant(from_tenant_id, to_tenant_id) {
        const payload = {
            from_tenant_id,
            to_tenant_id,
        }
        return this.postRequest('/api/private/transfer/tenant', payload).then(function(json) {
            return json
        },
        function(error) {
            return error
        })
    },
}